import { Component, input } from '@angular/core';

import { IconComponent } from '../../../components/icon/icon.component';
import { GoalType } from '../../../domain/lti/lti.enum';

@Component({
  selector: 'td-wb-goal-type-icon',
  template: '<td-wb-icon [iconId]="goalIconId" [size]="size()" />',
  imports: [
    IconComponent
  ]
})
export class GoalTypeIconComponent {

  private static readonly ICONS_MAP = new Map<GoalType, string>([
    [GoalType.RETIREMENT, 'lti-dashboard--retirement'],
    [GoalType.BUILD_WEALTH, 'lti-dashboard--build-wealth'],
    [GoalType.MAJOR_PURCHASE, 'lti-dashboard--major-purchase']
  ]);

  readonly goalType = input<GoalType>(undefined);
  readonly size = input<string>('1.7em');

  get goalIconId(): string {
    return GoalTypeIconComponent.ICONS_MAP.get(this.goalType());
  }
}

